import { getSupabase } from '@infra/supabase/client';

export interface ReferralLink { success: boolean; token?: string; expires_at?: string; error?: string }
export interface ReferralLookup {
  valid: boolean;
  workspace_name?: string;
  pipeline_name?: string;
  form_type?: 'enterprise' | 'default';
  expires_at?: string;
  status?: string;
}
export interface ReferralPayload {
  nome: string;
  telefone: string;
  email?: string;
  nomeContato?: string;
  numeroColaboradores?: string;
  partnerName: string;
  partnerEmail: string;
  context?: string;
  honeypot?: string;
}

const client = () => {
  const supabase = getSupabase();
  if (!supabase) throw new Error('Supabase não inicializado.');
  return supabase;
};

export const referralRepository = {
  createLink: async (pipelineId: string): Promise<ReferralLink> => {
    const { data, error } = await client().rpc('create_pipeline_referral_link', { p_pipeline_id: pipelineId });
    if (error) throw error;
    return data as unknown as ReferralLink;
  },
  lookup: async (token: string): Promise<ReferralLookup> => {
    const { data, error } = await client().rpc('lookup_pipeline_referral', { p_token: token });
    if (error) throw error;
    return data as unknown as ReferralLookup;
  },
  submit: async (token: string, payload: ReferralPayload) => {
    const { data, error } = await client().rpc('submit_pipeline_referral', {
      p_token: token,
      p_nome: payload.nome.trim(),
      p_telefone: payload.telefone.trim(),
      p_email: payload.email?.trim() || undefined,
      p_nome_contato: payload.nomeContato?.trim() || undefined,
      p_numero_colaboradores: payload.numeroColaboradores?.trim() || undefined,
      p_partner_name: payload.partnerName.trim(),
      p_partner_email: payload.partnerEmail.trim().toLowerCase(),
      p_context: payload.context?.trim() || undefined,
      p_honeypot: payload.honeypot || undefined,
    });
    if (error) throw error;
    return data as unknown as { success: boolean; message?: string; error?: string };
  },
};
